import { ComponentProps, FC } from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent } from './assets/singleView.svg';

export const SingleViewIcon: FC<ComponentProps<typeof SvgIcon>> = (props: any) => {
  return <SvgIcon {...props} component={ReactComponent} inheritViewBox />;
};
